// https://stackoverflow.com/questions/58278652/generic-enum-type-guard
export const isStringEnum =
  <T>(e: T) =>
  (token: any): token is T[keyof T] =>
    (Object as any).values(e).includes(token as T[keyof T]);
